module.exports = "/static/pdf/HK-Merchant-Contract.d9f41a46bf97054fee62c5a1f91bd042.pdf";